import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { InputCustom, HttpError, SelectWithSearch } from "../components"
import { LoadModal } from "./modais"
import Layout from "../views/Layout"
import * as ApiHelper from "../ApiHelper"
import Util from "../Util"
class RelatorioRecibos extends Component {
  constructor() {
    super()
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.onChangeDataInicio = this.onChangeDataInicio.bind(this)
    this.onChangeDataFinal = this.onChangeDataFinal.bind(this)
    this.onChangeUnidade = this.onChangeUnidade.bind(this)
    this.state = {
      dataDeInicio: "",
      dataFinal: "",
      unidades: [],
      unidade: "",
      showLoad: false
    }
  }

  componentWillMount() {
    this.getInitialFields()
  }
  componentDidUpdate() {
    //Pequeno ajuste tecnico devido bug no datepicker
    window.$(".is-empty").removeClass("is-empty")
  }

  getInitialFields() {
    ApiHelper.getUnidadesOrcametarias((data, error) => {
      if (data) {
        const unidades = Util.mapUnidades(data)
        unidades.shift()
        this.setState(
          {
            unidades: unidades
          },
          () => {
            window.$(".is-empty").removeClass("is-empty")
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  onChangeDataInicio(value) {
    var newValue = value
    this.setState({
      dataDeInicio: newValue
    })
  }
  onChangeDataFinal(value) {
    var newValue = value
    this.setState({
      dataFinal: newValue
    })
  }
  onChangeUnidade(event) {
    this.setState({
      unidade: event
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      end_date: this.state.dataFinal,
      start_date: this.state.dataDeInicio,
      unidade_id:
        this.state.unidade === "" ||
        this.state.unidade === null ||
        this.state.unidade === undefined
          ? undefined
          : this.state.unidade.value
    }
    this.toggleLoadModal()
    ApiHelper.getRecibosReport(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Histórico de serviços realizados.pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.setState({
          formError: "Ocorreram erros"
        })
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  render() {
    if (this.state.httpError) {
      return (
        <HttpError
          message={this.state.httpError.message}
          status={this.state.httpError.status}
        />
      )
    }
    return (
      <Layout>
        <div className="card card-plain">
          <div className="card-header" data-background-color="as-blue">
            <h4 className="title">Histórico de serviços realizados</h4>
            <p className="category">Todos os recibos emitidos</p>
          </div>
          <div className="card-content">
            <div className="row">
              <SelectWithSearch
                error={this.state.formError}
                sizeClass="col-md-6"
                options={this.state.unidades}
                label="Unidade orçamentária"
                placeholder="Selecione uma unidade orçamentária ou deixe em branco para selecionar todas"
                onChange={this.onChangeUnidade}
                value={this.state.unidade}
              />
            </div>
            <div className="row">
              <LoadModal
                onClose={this.toggleLoadModal}
                show={this.state.showLoad}
              />
              <InputCustom
                sizeClass="col-md-3"
                type="date"
                label="Data inicial"
                onChange={this.onChangeDataInicio}
                value={this.state.dataDeInicio}
              />
              <InputCustom
                sizeClass="col-md-3"
                type="date"
                label="Data final"
                onChange={this.onChangeDataFinal}
                value={this.state.dataFinal}
              />
            </div>
            <div className="row">
              <button
                onClick={this.sendForm}
                type="submit"
                className="btn btn-primary pull-left"
                data-background-color="as-blue"
              >
                Gerar
              </button>
            </div>
            <span className="label label-primary">
              PS:Se as datas forem deixadas em branco, todo o período de
              existencia do sistema será contemplado
            </span>
            <br />
            <span className="label label-inverse">
              PS 2:Se a unidade orçamentária não for selecionada, todas serão
              contempladas
            </span>
          </div>
        </div>
      </Layout>
    )
  }
}
export default withRouter(RelatorioRecibos)



// WEBPACK FOOTER //
// ./src/views/RelatorioRecibos.js